import * as styles from "./ParagraphQuote.module.scss";

import { graphql } from "gatsby";
import React from "react";
import { QuoteMarks } from "../../../components/common/Icons";
import { Colours } from "../../../utils/colours";
import WrappedSection from "../../WrappedSection/WrappedSection";

export interface ParagraphQuoteProps {
	quote: string;
	quotee: string;
	quoteeRole: string;
	highlighted?: boolean;
}

export const getParagraphQuoteProps = ({
	field_quote,
	field_quotee,
	field_quotee_role,
	field_is_highlighted,
}: Queries.ParagraphQuoteDataFragment): ParagraphQuoteProps => ({
	quote: field_quote,
	quotee: field_quotee,
	quoteeRole: field_quotee_role,
	highlighted: field_is_highlighted,
});
export const ParagraphQuote: React.FC<ParagraphQuoteProps> = ({
	quote,
	quotee,
	quoteeRole,
	highlighted,
}) => {
	return (
		<WrappedSection sectionName="ParagraphQuote">
			<div
				className={
					highlighted ? styles.paragraphquotehighlighted : styles.paragraphquote
				}
			>
				<div className={styles.content}>
					<div className={styles.quote}>
						<div className={styles.quotemarks}>
							<QuoteMarks
								fill={highlighted ? Colours.WHITE : Colours.SUNSHINE_YELLOW}
								height={"63px"}
								width={"48px"}
							/>
						</div>
						<q className={styles.quotetext}>
							{quote}
							<QuoteMarks
								fill={highlighted ? Colours.WHITE : Colours.SUNSHINE_YELLOW}
								height={"34px"}
								width={"29px"}
							/>
						</q>
					</div>
					<p className={styles.quotee}>
						{quotee}
						{quoteeRole && (
							<span className={styles.quoteerole}>, {quoteeRole}</span>
						)}
					</p>
				</div>
			</div>
		</WrappedSection>
	);
};

export default ParagraphQuote;

export const fragment = graphql`
    fragment ParagraphQuoteData on paragraph__quote {
        __typename
        id
        field_quote
        field_quotee
        field_quotee_role
		field_is_highlighted
    }
`;
